import React from "react";
//Limitless imports
import { log as pilog } from "@limitless/common/utils";
import { useNotificationContext } from "@limitless/common/hooks";
const INITIAL_STATE = [];
export const useSessionErrors = () => {
  const log = pilog.getLogger("useSessionErrors");
  const [sessionErrors, setSessionErrors] = React.useState(INITIAL_STATE);
  const {
    addFailureNotification
  } = useNotificationContext();
  log.debug(sessionErrors);
  const addSessionError = error => {
    const newErrors = [...sessionErrors, ...[error]];
    setSessionErrors(newErrors);
  };
  const addSessionErrorAndNotify = (actionName, errorMessage, notification) => {
    addFailureNotification(notification || errorMessage);
    addSessionError({
      messageId: "",
      date: new Date(),
      action: actionName,
      platformMeaning: errorMessage
    });
  };

  /** To be used for Graph QL API errors */
  const addErrorAndNotify = (error, message, actionName, notification) => {
    var _error$error;
    addFailureNotification(notification);
    log.debug(error);
    let platformMeaning = notification;
    if (error !== null && error !== void 0 && (_error$error = error.error) !== null && _error$error !== void 0 && _error$error.message) {
      platformMeaning = error.error.message;
    }
    if (error !== null && error !== void 0 && error.message) {
      platformMeaning = error.message;
    }
    addSessionError({
      messageId: message === null || message === void 0 ? void 0 : message.messageId,
      date: new Date(),
      action: actionName,
      platformMeaning
    });
  };
  const addPlatformSessionError = (error, message, action) => {
    log.debug("Adding!");
    let platformMeaning = "";
    let messageDesc = "";
    if (error && error.response && error.response.data) {
      platformMeaning = error.response.data.meaning;
      messageDesc = error.response.data.message;
    }
    addSessionError({
      messageId: message.messageId,
      date: new Date(),
      action: action.name,
      platformMeaning,
      messageDesc
    });
  };
  const removeSessionErrors = rows => {
    const indexArray = [];
    log.debug(rows);
    rows.data.map(error => {
      indexArray.push(error.dataIndex);
    });
    const newErrors = sessionErrors.filter((error, index) => {
      return !indexArray.includes(index);
    });
    setSessionErrors(newErrors);
  };

  // Make the context object:
  return {
    sessionErrors,
    addPlatformSessionError,
    addSessionError,
    removeSessionErrors,
    addErrorAndNotify,
    addSessionErrorAndNotify
  };
};